module.exports = __webpack_public_path__ + "img/header3.9cde66b9.jpg";